export default [
  {
    path: '/banner/list/:ref',
    name: 'banner-list',
    component: () =>
      import('@/views/pages/banner/banner-list/BannerList.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner List',
        active: true,
      },
    ],
  },
  {
    path: '/banner/group/:ref',
    name: 'banner-group',
    component: () =>
      import('@/views/pages/banner/banner-group/BannerGroup.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Group',
        active: true,
      },
    ],
  },
  {
    path: '/banner/set/:ref',
    name: 'set-banner',
    component: () =>
      import('@/views/pages/banner/set-banner/SetBanner.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Set List',
        active: true,
      },
    ],
  },
  {
    path: '/banner/list/:ref/create',
    name: 'create-banner',
    component: () =>
      import('@/views/pages/banner/banner/CreateBanner.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner List',
      },
      {
        text: 'Add Banner',
        active: true,
      },
    ],
  },
  {
    path: '/banner/list/:ref/:bannerId/info',
    name: 'banner-info',
    component: () =>
      import('@/views/pages/banner/banner/BannerInfo.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner List',
      },
      {
        text: 'Banner Info',
        active: true,
      },
    ],
  },
  {
    path: '/banner/set/:ref/create',
    name: 'create-set-banner',
    component: () =>
      import(
        '@/views/pages/banner/create-set-banner/CreateSetBanner.vue'
      ),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Set',
      },
      {
        text: 'Banner Set List',
      },
      {
        text: 'Create Banner Set ',
        active: true,
      },
    ],
  },
  {
    path: '/banner/group/:ref/create',
    name: 'create-banner-group',
    component: () =>
      import(
        '@/views/pages/banner/create-edit-group-banner/CreateGroupBanner.vue'
      ),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Group',
      },
      {
        text: 'Banner Group List',
      },
      {
        text: 'Create Banner Group',
        active: true,
      },
    ],
  },
  {
    path: '/banner/set/:ref/:setBannerId/info',
    name: 'set-banner-info',
    component: () =>
      import(
        '@/views/pages/banner/set-banner-info/SetBannerInfo.vue'
      ),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Set',
      },
      {
        text: 'Banner Set List',
      },
      {
        text: 'Banner Set Info',
        active: true,
      },
    ],
  },
  {
    path: '/banner/set/:ref/:setBannerId/info/banner/:bannerId/info',
    name: 'set-banner-info-edit-banner',
    component: () =>
      import('@/views/pages/banner/banner/BannerInfo.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Set',
      },
      {
        text: 'Banner Set Info',
      },
      {
        text: 'Banner Info',
        active: true,
      },
    ],
  },
  {
    path: '/banner/group/:ref/:id/info',
    name: 'group-banner-info',
    component: () =>
      import(
        '@/views/pages/banner/create-edit-group-banner/GroupBannerDetail.vue'
      ),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Group',
      },
      {
        text: 'Banner Group List',
      },
      {
        text: 'Banner Group Info',
        active: true,
      },
    ],
  },
  {
    path:
      '/banner/group/:ref/:bannerGroupId/info/set/:setBannerId/info',
    name: 'group-banner-info-edit-set-banner',
    component: () =>
      import(
        '@/views/pages/banner/set-banner-info/SetBannerInfo.vue'
      ),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Group',
      },
      {
        text: 'Banner Group Info',
      },
      {
        text: 'Banner Set Info',
        active: true,
      },
    ],
  },
  {
    path:
      '/banner/group/:ref/:bannerGroupId/info/set/:setBannerId/info/banner/:bannerId/info',
    name: 'group-banner-info-edit-set-banner-edit-banner',
    component: () =>
      import('@/views/pages/banner/banner/BannerInfo.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Group Info',
      },
      {
        text: 'Banner Set Info',
      },
      {
        text: 'Banner Info',
        active: true,
      },
    ],
  },
  {
    path: '/banner/group/:ref/set/:setBannerId/info',
    name: 'group-banner-list-edit-set-banner',
    component: () =>
      import(
        '@/views/pages/banner/set-banner-info/SetBannerInfo.vue'
      ),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Group',
      },
      {
        text: 'Banner Set Info',
        active: true,
      },
    ],
  },
  {
    path:
      '/banner/group/:ref/set/:setBannerId/info/banner/:bannerId/info',
    name: 'group-banner-list-edit-set-banner-edit-banner',
    component: () =>
      import('@/views/pages/banner/banner/BannerInfo.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Group',
      },
      {
        text: 'Banner Set Info',
      },
      {
        text: ' Banner Info',
        active: true,
      },
    ],
  },
  {
    path:
      '/banner/group/:ref/:bannerGroupId/info/banner/info/:bannerId',
    name: 'group-banner-info-edit-banner',
    component: () =>
      import('@/views/pages/banner/banner/BannerInfo.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Group',
      },
      {
        text: 'Banner Group Info',
      },
      {
        text: 'Banner Info',
        active: true,
      },
    ],
  },
  {
    path: '/banner/group/:ref/banner/info/:bannerId',
    name: 'group-banner-list-edit-banner',
    component: () =>
      import('@/views/pages/banner/banner/BannerInfo.vue'),
    meta: {},
    breadcrumb: [
      {
        text: 'Banner Management',
      },
      {
        text: 'Banner Group',
      },
      {
        text: 'Banner Group List',
      },
      {
        text: 'Banner Info',
        active: true,
      },
    ],
  },
];
